/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-10",
    versionChannel: "nightly",
    buildDate: "2023-12-10T00:15:08.273Z",
    commitHash: "27e1e1477a16ac26d2849cd647ccfe973776c7c8",
};
